import { render, staticRenderFns } from "./RejectionReasonModal.vue?vue&type=template&id=2b1e64a2"
import script from "./RejectionReasonModal.vue?vue&type=script&lang=js"
export * from "./RejectionReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports